import uuid from "react-uuid";

export const myID = uuid()